import { render, staticRenderFns } from "./FCXDataDescription.vue?vue&type=template&id=72a180f0&scoped=true"
import script from "./FCXDataDescription.vue?vue&type=script&lang=js"
export * from "./FCXDataDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a180f0",
  null
  
)

export default component.exports